<template>
  <div class="delete-team-from-stage-tournament-wrapper">
    <h5>Вы действительно хотите удалить <b>{{ params.team.name }}</b> из Этапа <b>{{ params.stage.name }}</b>?</h5>
    <h5 class="font-weight-bold mt-3">Укажите причину:</h5>
    <div v-for="reason in reasonsForDelete" :key="'reasonId' + reason.id" class="form-check">
      <input class="form-check-input"
             type="radio" name="reasonsForDelete"
             :id="reason.id"
             v-model="formModel.reject_description"
             :value="reason.text">
      <label class="form-check-label" :for="reason.id">{{reason.text}}</label>
    </div>
    <footer>
      <b-button @click="submitForm" :disabled="isLoadingSaveForm">
        {{ isLoadingSaveForm ? 'Удаляем...' : 'Удалить' }}
      </b-button>
    </footer>
    <b-alert v-if="errorText" show variant="danger" style="margin: 10px 0 0 0">{{ errorText }}</b-alert>
  </div>
</template>

<script>
import api from "@/api/api";
import {mapState} from "vuex";
import {reasonsForDelete} from '@/constants/reasonsForDeleteTeam';
import {clearTeamFromMlbbGrid} from "@/common/clearTeamFromMlbbGrid";

export default {
  name: "DeleteTeamFromStageTournament",
  props: {
    params: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      reasonsForDelete,
      isLoadingSaveForm: false,
      errorText: null,
      selectedReason: '',
      formModel: {
        reject_description: ''
      }
    }
  },
  computed: {
    ...mapState('moduleNewTournament', ['selectedGroupId', 'tournament']),
    isMlbb() {
      return this.tournament?.game?.slug === 'mlbb'
    }
  },
  methods: {
    async submitForm() {
      try {
        this.isLoadingSaveForm = true
        await api.teams.deleteTeamFromStage(
            this.params.team.stage_team_id,
            {...(this.formModel.reject_description && {delete_description: this.formModel.reject_description})})
        // Команда снята с этапа — её ячейки в сетке этого этапа становятся пустыми
        if (this.isMlbb) await this.clearGridCells()
        await this.$store.dispatch('moduleNewTournament/getTournament', {
          id: this.$route.params.standingId
        })
        if (this.selectedGroupId) {
          await this.$store.dispatch('moduleNewTournament/getTeamsByGroup', { id: this.selectedGroupId })
        }
        this.$emit('submit', this.params.team)
        this.$emit('closeModal')
      } catch (e) {
        const message = e.response.data.message
        let errors = ''
        if (e.response.data.errors) errors = Object.entries(e.response.data.errors).map(([ name, values ]) => `${ name }: ${ values.join(', ') }`).join('. ')
        this.errorText = `${ message }; ${ errors }.`
      } finally {
        this.isLoadingSaveForm = false
      }
    },
    async clearGridCells() {
      const { failed } = await clearTeamFromMlbbGrid({
        stageIds: [this.params.stage?.id].filter(Boolean),
        teamId: this.params.team?.id
      })
      if (failed) this.$root.$bvToast.toast('Команда снята с этапа, но не из всех матчей сетки — проверьте сетку вручную', {
        title: 'Сетка',
        variant: 'warning',
        solid: true,
        autoHideDelay: 5000
      })
    }
  }
}
</script>

<style scoped lang="scss">
.delete-team-from-stage-tournament-wrapper {
  h5 {
    font-size: 16px;
    font-weight: 400;
  }
  footer {
    border-top: 1px solid #dee2e6;
    padding-top: 15px;
    margin-top: 15px;
    text-align: right;
  }
}
</style>